<div class="c-payment-details-breakdown-item">
  <div class="c-payment-details-breakdown-item_titleblock">
    <!--搭乗者姓名-->
    <div class="c-payment-details-breakdown-item_titleblock_title">{{ dispName }}</div>
    <!-- 搭乗者種別 -->
    <div class="c-payment-details-breakdown-item_titleblock_subtitle" [innerHTML]="type | staticMsg"></div>
  </div>
  <!--運賃 又は 必要マイル数 -->
  <div class="c-payment-details-breakdown-item_items">
    <div class="c-payment-details-breakdown-item_items_title">
      <div [innerHTML]="(isAwardBooking ? 'label.requiredMileage' : 'label.fare') | staticMsg"></div>
      <div>
        <span
          class="not-bold c-modified-element"
          [innerHTML]="
            isAwardBooking
              ? (paxRequiredMiles | milesFormat : 'currencyUnit.MIL')
              : (data.unitTotalFee | amountFormat : undefined : data.currencyCode)
          "
        ></span>
      </div>
    </div>
  </div>
  <!--税金・料金等詳細 -->
  <div class="c-payment-details-breakdown-item_items">
    <div class="c-payment-details-breakdown-item_items_title">
      <div [innerHTML]="'label.totalTax' | staticMsg"></div>
    </div>
    <!-- 各国諸税 -->
    <div *ngFor="let tax of taxes" class="c-payment-details-breakdown-item_items_content">
      <div class="c-payment-details-breakdown-item_items_content_title" [innerHTML]="tax.name"></div>
      <div [innerHTML]="tax.value | amountFormat : undefined : data.currencyCode"></div>
    </div>
  </div>
  <!-- 発行手数料 -->
  <div class="c-payment-details-breakdown-item_items">
    <div class="c-payment-details-breakdown-item_items_title">
      <div [innerHTML]="'label.fee' | staticMsg"></div>
      <!-- 金額 0 固定 -->
      <div>
        <span
          class="u-not-bold"
          [innerHTML]="data.ticketingSurchargeTax | amountFormat : undefined : data.currencyCode"
        ></span>
      </div>
    </div>
  </div>
</div>
